import { useEffect, useState } from 'react'
import { userAPI, type MineMerke } from '../services/api'
import i18n from '../i18n'
import { localizeApiDetail } from '../i18n/apiError'

export function useMineMerker() {
  const [items, setItems] = useState<MineMerke[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const refresh = async () => {
    try {
      setLoading(true)
      const res = await userAPI.getMineMerker()
      setItems(res.data?.items ?? [])
      setError(null)
    } catch (err: any) {
      setError(localizeApiDetail(err?.response?.data?.detail) || err?.message || i18n.t('errors.loadMerker'))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    refresh()
  }, [])

  /** Set of active brand display names for fast lookup in tables */
  const activeMerker = new Set(
    items.filter(m => m.is_active).map(m => m.merke_navn)
  )

  return { items, loading, error, refresh, activeMerker }
}
